import PropTypes from 'prop-types'

/**
 * @param {string} className - classes that you want to put on the icon.
 * @param {string} color - color that you want to put on the Icon.
 * @returns {React.ReactNode} - return an Check Icon. 
 */
export function Check(props) {
    const { className, color="currentColor" } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none"  className={className}>
                <path fillRule="evenodd" clipRule="evenodd" d="M23.2827 0.716072C24.2391 1.67083 24.2391 3.21881 23.2827 4.17357L10.1501 17.2839C9.19367 18.2387 7.64306 18.2387 6.68668 17.2839L0.71729 11.3247C-0.239097 10.3699 -0.239097 8.82194 0.71729 7.86717C1.67368 6.91241 3.22428 6.91241 4.18067 7.86717L8.41837 12.0977L19.8193 0.716072C20.7757 -0.238691 22.3263 -0.238691 23.2827 0.716072Z" fill={color} />
        </svg>
    );
}

Check.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
}